import jwtDecode from "jwt-decode";
import axios from "axios";
import { getPresignedUrlForFile } from "../helperApi/helperApi";
import { allInstanceData, config } from "../config";
const backEndUrl = process.env.REACT_APP_API_ENDPOINT;
export const numberInputOnWheelPreventChange = (e) => {
  // Prevent the input value change
  e.target.blur()

  // Prevent the page/container scrolling
  e.stopPropagation()

  // Refocus immediately, on the next tick (after the current function is done)
  setTimeout(() => {
    e.target.focus()
  }, 0)
}

export const validateUser = (navigate) => {
  let token = localStorage.getItem('Token');
  if (!token) {
    navigate('/');
    return false;
  } else {
    let decode = jwtDecode(token);
    if (decode.userType != "user") {
      return false;
    }
  }
  return true;
}


export const extractURLAndEncodedFilename = (url) => {
  const normalizedURL = url.replace(/[\\/]/g, '/');

  // Split the normalized URL by the last '/'
  const parts = normalizedURL.split('/');
  const filename = parts[parts.length - 1];

  // URL encode the extracted filename
  const encodedFilename = encodeURIComponent(filename.trim());

  // Extract the URL without the filename
  const urlWithoutFilename = normalizedURL.substring(0, normalizedURL.lastIndexOf('/') + 1);

  return {
    url: urlWithoutFilename,
    encodedFilename: encodedFilename
  };
}

export const currencyFormatter = (amount) => {
  const currency = config.name == allInstanceData?._8xP ? "USD" : "EUR";
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    // These options are needed to round to whole numbers if that's what you want.
    minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
  });

  return formatter.format(amount);
};

export const checkIfAllPartsInvoicedForPO = (purchaseOrder) => {
  let localAvailableQtyData = {};
  purchaseOrder?.supplierRfqOfferId?.partsData?.forEach((lineItem) => {
    localAvailableQtyData[lineItem._id] = lineItem.qty;
  });
  purchaseOrder?.billsForPurchaseOrder?.forEach((item) => {
    item?.partsData?.forEach((lineItem) => {
      localAvailableQtyData[lineItem.partItemId] =
        localAvailableQtyData[lineItem.partItemId] - lineItem?.shippedQty;
    });
  });
  let listOfAvailableQtyValues = Object.values(localAvailableQtyData);
  let isAllQtyInvoiced = true;
  if (listOfAvailableQtyValues.some(item => item > 0)) {
    isAllQtyInvoiced = false;
  }
  return isAllQtyInvoiced;
}

export const getFileExtension = (filename) => {
  return filename?.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
}


export const isValidFileName = (name) => {
  const type = getFileExtension(name)?.toUpperCase();
  if (type === "STP" || type === "STEP" || type === "IGES" || type === "OBJ" || type === "STL") return true;
  return false;
}



export const downloadFileFromS3 = async (s3FileObject) => {
  try {
    if (!s3FileObject.bucket || !s3FileObject.key) {
      toast.error("File details are missing. Please verify the file information or contact support for assistance.");
      return;
    }

    const signedUrl = await getPresignedUrlForFile(s3FileObject.bucket, s3FileObject.key);

    console.log('singedURl', signedUrl);
    if (!signedUrl) {
      toast.error("Unable to retrieve the file. Please try again or contact support for further assistance.");
      return;
    }

    const link = document.createElement("a");
    link.href = signedUrl;
    link.download = s3FileObject.key.split('/').pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error("Error downloading file:", err);
    toast.error("An unexpected error occurred while downloading the file. Please try again or contact support.");
  }
};